import { useContext } from "react"
import { ScientGlobalContext } from "../ScientGlobalStateProvider"

export const useGlobalState = () => {
  return useContext(ScientGlobalContext)
}
